import React, { useEffect } from 'react';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { useTheme } from '@mui/material/styles';
import { Stack, Box, Paper, LinearProgress, Typography } from '@mui/material';
import HeaderPage from './HeaderPage';
import FilterBar from './FilterBar';
import List from './List';
import utils from 'components/utils';
import moment from 'moment';

const Home = props => {
	const theme = useTheme();
	const translate = utils.useI18N();
	const iCan = utils.usePermissions();
	const token = useStoreState(state => state.kit.filters.list.token);
	const status = useStoreState(state => state.kit.filters.list.status);
	const loading = useStoreState(state => state.kit.list.loading);
	const retrieve = useStoreActions(dispatch => dispatch.kit.list.retrieve);
	const items = useStoreState(state => state.kit.list.items);
	const setToken = useStoreActions(dispatch => dispatch.kit.filters.setToken);
	const setViewRows = useStoreActions(dispatch => dispatch.kit.list.setViewRows);

	const search = () => {
		const searchList = token
			.trim()
			.toLowerCase()
			.split(' ');
		return items.filter(item => {
			let result = false;
			for (let word of searchList) {
				if (
					item.id.toString().includes(word) ||
					item.name.toLowerCase().includes(word) ||
					item.internalCode.toLowerCase().includes(word)
				) {
					result = true;
				}
			}
			return result;
		});
	};

	const filterStatus = rows => {
		if (status.length == 0) return rows;
		let filteredRows = rows;
		if (status.includes('ENABLED')) filteredRows = filteredRows.filter(item => item.enabled);
		if (status.includes('DELIVERABLE'))
			filteredRows = filteredRows.filter(item => moment(item.deliveryDate).diff(moment(), 'days') <= 0);
		if (status.includes('VISIBLE'))
			filteredRows = filteredRows.filter(item => moment(item.dateFrom).diff(moment(), 'days') <= 0);
		if (status.includes('AVAILABLE')) filteredRows = filteredRows.filter(item => item.available > item.committed);
		return filteredRows;
	};

	const handleRows = () => {
		if (items.length == 0) return;
		if (!token.trim()) setViewRows(filterStatus(items));
		else setViewRows(filterStatus(search()));
	};

	useEffect(() => {
		setToken('');
		retrieve();
	}, []);

	useEffect(() => {
		handleRows();
	}, [token, items, status]);

	return (
		<Stack
			direction="column"
			justifyContent="flex-start"
			alignItems="flex-start"
			spacing={0}
			sx={{ minHeight: '100vh' }}
		>
			<Paper variant="stickyTop">
				<HeaderPage />
				<FilterBar />
				{loading && (
					<Box sx={{ width: '100%' }}>
						<LinearProgress sx={{ color: theme.palette.primary.main }} />
					</Box>
				)}
			</Paper>
			{!loading && items.length == 0 && (
				<Box sx={{ width: '100%', textAlign: 'center', marginTop: '20px !important' }}>
					<Typography variant="titleSection">{translate('kit.noKit')}</Typography>
				</Box>
			)}
			{!loading && items.length > 0 && <List />}
		</Stack>
	);
};

export default Home;
